import { TextField, inputBaseClasses, MenuItem, menuItemClasses, autocompleteClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
const PatientListItemWrapper = styled("span")(() => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%"
}));
const PatientListItem = styled("span")(() => ({
  marginLeft: "8px",
  marginRight: "32px",
  fontWeight: 700,
  fontSize: "13px"
}));
const PatientAddressListItem = styled("span")(() => ({
  fontWeight: 500,
  fontSize: "11px",
  textAlign: "right"
}));
const PatientInput = styled(TextField)(() => ({
  "&&&": {
    width: "100%",
    background: "#EDF8F7",
    [`.${inputBaseClasses.root}`]: {
      border: "none",
      background: "transparent",
      fontSize: "15px",
      fontFamily: "inherit",
      outline: "none",
      padding: 0,
      width: "100%",
      input: {
        padding: 0,
        fontSize: "15px",
        fontFamily: "Lato,sans-serif",
        fontWeight: 700,
        backround: "transparent"
      },
      "& > fieldset": {
        border: "none",
        width: "100%"
      }
    }
  }
}));
const StyledMenuItem = styled(MenuItem)(() => ({
  "&&": {
    fontSize: 13,
    width: "100%"
  },
  [`&.${menuItemClasses.root}`]: {
    paddingTop: 12,
    paddingBottom: 12,
    color: "#004734",
    backgroundColor: "#fff",
    width: "100%",
    [`&:hover:not(.${menuItemClasses.selected}, .${menuItemClasses.focusVisible})`]: {
      backgroundColor: "#caede7",
      [`span`]: {
        color: "#004734"
      }
    },
    [`&.${menuItemClasses.selected}, &.${menuItemClasses.focusVisible}, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}`]: {
      backgroundColor: "#00624F",
      color: "#fff",
      [`span, p`]: {
        color: "#fff"
      }
    },
    [`&.${menuItemClasses.selected}:hover, &.${menuItemClasses.selected}.${menuItemClasses.focusVisible}:hover, &.${menuItemClasses.focusVisible}:hover`]: {
      backgroundColor: "#004734"
    },
    [`&.${autocompleteClasses.option}`]: {
      backroundColor: "#fff",
      "&:hover, &.Mui-focused": {
        backgroundColor: "#A8DDD6"
      },
      '&[aria-selected="true"]': {
        backgroundColor: "#6BC8BC",
        "&.Mui-focused": {
          backgroundColor: "#004734",
          color: "#fff",
          "&:hover": {
            "span, p": {
              color: "#fff"
            }
          }
        }
      }
    }
  }
}));
export {
  PatientAddressListItem,
  PatientInput,
  PatientListItem,
  PatientListItemWrapper,
  StyledMenuItem
};
